<template>
   <div>
       
        <div  class="g_desktopOn" >
                <div class="title is-4" style="padding-left: 20px" v-if="club">
                    <div>
                    <s-l id="list__title_season" :v="state=='INPROGRESS' ? 'en cours de ' + club.name : 'archivés de ' + club.name ">Liste des saisons %v </s-l>
                    </div>
                    <s-button :icon="state=='INPROGRESS' ? 'database' : 'play' " 
                        :label="state=='INPROGRESS' ? 'Archivés' : 'En cours' " theme="is-primary" 
                        @onclick="state=='INPROGRESS' ? state='FINISH' : state='INPROGRESS'"/>
                    <div style="float:right">
                        <s-you-tube id="video_saison" :club="club"  />
                    </div>
                </div>
                    
        </div>
        <div class="g_menuMobile">
            <table class="g_menuFooter">
                <tr>
                    <td colspan="4" class="g_headerFooter">Liste des saisons 
                        <span v-if="state=='INPROGRESS'">en cours</span>
                        <span v-if="state=='FINISH'">archivés</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div class="g_buttonFooter">
                            <s-button theme="is-light" 
                                label="" 
                                icon="bookmark" 
                                @onclick="goClub()" 
                            />
                        </div>
                        <span>
                            Club
                        </span>
                    </td>
                    <td>
                    <div class="g_buttonFooter">
                            <s-button theme="is-light" 
                                label="" 
                                :icon="state=='INPROGRESS' ? 'database' : 'play'" 
                                @onclick="state=='INPROGRESS' ? state='FINISH' : state='INPROGRESS'" 
                            />
                        </div>
                        <span v-if="state=='INPROGRESS'">Archive</span>
                        <span v-if="state=='FINISH'">En cours</span>
                    </td>
                    <td>
                    </td>
                    <td>
                        
                    </td>
                </tr>
            </table>

        </div>
        <add-tournoi 
            :open="openModalTournoi" 
            :club="club" 
            @close="openModalTournoi=false" 
            :tournoi="tournoiInit"
            :saison="saisonInit"
            v-if="club"
        />
        <div v-if="saisons.length==0" class="g_notItems">
            <s-l id="notSeason"> Aucune saison pour ce club pour le moment</s-l>
        </div>
       
        <div class="listSaisons">
        
        <div v-for="saison in saisons" class="saison" v-if="saison.state==state" >
                <div class="sheader">
                    <span >{{saison.nom}}</span>
                    <div style="float:right" v-if="$getRole()!='visiteur'">
                        <s-button icon="trash" :role="role" theme="is-danger is-small" @onclick="openModalDelete(saison)" label=""/>
                    </div>
                </div>
                <div v-on:click="listTournois(saison)">
                <div class="state">
                    <span v-if="saison.state=='INPROGRESS'">En cours</span>
                    <span v-if="saison.state=='FINISH'">TERMINE</span>
                </div>
                <saison-detail :saison="saison" :club="club"/>
                 <div class="description">
                    {{saison.description}}
                </div>
                <div v-if="saison.state=='FINISH'" style="margin-bottom: 5px;text-align:center">
                    <s-button label="Réactiver la saison" @onclick="reactiverSaison(saison)" theme="is-warning is-medium"/>
                </div>
                </div>
            
        </div>
        </div>
        <s-confirm 
            title="Supprimer une saison"
            @yes="deleteSaison"
            @no="modalDeleteSaison=false"
            :open="modalDeleteSaison"
           
        >
            <h1 class="title is-5"  v-if="saison!=null">
                <s-l id="season_delete" :v="saison.nom">Etes vous sûr de vouloir supprimer la saison "%v" ?</s-l>
                <br/>
                <s-l id="season_tournoi_delete">Tous les tournois seront supprimés (même ceux clotûrer)</s-l>
            </h1>
        </s-confirm>
   </div>
</template>
<style scoped>
    @media screen and (max-width: 420px) {
        .listSaisons {
            padding-top: 0px;
            margin-bottom: 100px;
        }
    }
    @media screen and (min-width: 420px) {
        .listSaisons {
            padding-top: 100px;
        }
    }
    .sheader {
        background-color: var(--bluebg);
        color:white;
        padding: 10px;
        font-weight: bolder;
         vertical-align: middle;
    }
    .description {
        height: 100px;
        font-size: 14px;
        padding: 10px;
    }
    .saison {
        display: inline-block;
        width: 90%;
        max-width: 400px;
        vertical-align: top;
        border: thin silver solid;
        margin-left: 20px;
        margin-bottom: 20px;
        background-color: rgba(242, 242, 243, 0.4);
    }
    .saison:hover {
         background-color: #d5d9e6;
        cursor: pointer;
    }

    .state {
        font-weight: bolder;
        padding-left: 20px;
        font-size: 22px;
        margin-top: 20px;
        color: black;
    }
</style>
<script>
import club_fct from "@/firebase/club.js"
import saison_fct from "@/firebase/season.js"
import AddTournoi   from '@/views/tournoi/list/addTournoi.vue'
import saisonDetail   from '@/views/season/detailSeason.vue'
import  tournoi_fct from "@/firebase/tournoi"
import firebase_api from "@/firebase/firebase_api"
import navbarTournoi from "@/views/tournoi/navbar.vue"
export default {
    components: {
        AddTournoi,
        navbarTournoi,
        saisonDetail
    },
    computed: {
        role: {
            get() {
            var idUser = this.$store.getters.getUser.authId;
            if (this.club!=null) {
                if (typeof(this.club.users) != "undefined")
                    if (typeof(this.club.users[idUser]) == "undefined"){
                        return "player"
                    }
                    else {
                        
                        return  this.club.users[idUser].role;
                    }
                }
            }
        }
    },
    data() {
        return {
            club: null,
            saison: null,
            openModalTournoi: false,
            saisonInit: JSON.parse(JSON.stringify(saison_fct.object.data)),
            tournoiInit: JSON.parse(JSON.stringify(saison_fct.object.tournoi)),
            modalDeleteSaison: false,
            state: "INPROGRESS",
            saisons: []
        }
    },
    mounted() {
        var idClub = this.$route.params.id;
        this.$bind("saisons", firebase_api.api.getDb().collection('club').doc(this.$route.params.id).collection("saisons")
                .orderBy("date"));
        club_fct.object.get(idClub, clubData=>{
            this.club = clubData;            
        })
        
    },
    methods: {
        reactiverSaison(saison) {
            saison.state="INPROGRESS";
            saison_fct.object.set(this.club, saison);
        },
        create() {
            
            this.openModalTournoi = true;
            this.saisonInit = JSON.parse(JSON.stringify(saison_fct.object.data))
            this.tournoiInit = JSON.parse(JSON.stringify(saison_fct.object.tournoi))
        },
        edit(saisonEdit) {
            this.openModalTournoi = true;
            this.saisonInit = JSON.parse(JSON.stringify(saisonEdit));
        },
        openModalDelete(saisonDelete) {
            this.saison = JSON.parse(JSON.stringify(saisonDelete));
            this.modalDeleteSaison = true;
        },
        deleteSaison() {
            saison_fct.object.delete(this.club, this.saison, ()=>{
                
            })
            this.modalDeleteSaison = false;
        },
        listTournois(saison) {
            this.$router.push({name: "tournoisSeason" , params: {id: this.club.id, idSeason: saison.id}});
        },
        
         close() {
             this.$router.push({name: "club" });
        },
        goClub() {
             this.$router.push({name: "viewClub", params: {id: this.club.id}});
        }
    }
}
</script>